// src/pages/HormonesWeightMoodEnergy.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

export default function Hormones() {
  const navigate = useNavigate();

  return (
    <div className="font-sans">

      {/* ================= HERO ================= */}
      <section className="bg-gradient-to-br from-pink-50 via-white to-purple-50 py-24 px-6 text-center">
        <h1 className="text-4xl md:text-5xl font-extrabold text-pink-700 leading-tight">
          Hormones That Control Weight,
          <br/> Mood & Energy
        </h1>

        <p className="mt-6 max-w-3xl mx-auto text-gray-700 text-lg md:text-xl">
          Weight, energy, and mood aren’t just about diet or exercise — hormones play a major role in how you feel and function every day.
        </p>

      </section>

      {/* ================= CONTENT WITH LEFT IMAGE ================= */}
      <section className="max-w-4xl mx-auto px-6 py-16 space-y-16 text-gray-700">

        {/* 1️⃣ Key Hormones That Affect Weight & Mood */}
        <div className="flex flex-col md:flex-row items-start gap-6">
          <img
            src="/assets/Glow Picks.jpg"
            alt="Hormones Control Weight and Energy"
            className="w-full md:w-1/4 rounded-xl shadow-lg"
          />
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-bold text-pink-600 mb-3">
              Key Hormones That Affect Weight, Mood & Energy
            </h2>
            <p className="text-lg md:text-xl mb-2">
              Hormones are chemical messengers that influence metabolism, energy levels, mood, sleep, and appetite. When key hormones are out of balance, women may notice changes in weight, mood swings, fatigue, or low motivation.
            </p>
            <ul className="list-disc list-inside ml-4 text-lg md:text-xl space-y-2">
              <li><span className="font-semibold text-pink-500">Insulin:</span> Regulates blood sugar and fat storage. Imbalances may cause cravings and weight gain.</li>
              <li><span className="font-semibold text-pink-500">Cortisol:</span> The stress hormone. High levels can increase fat storage, lower energy, and affect mood.</li>
              <li><span className="font-semibold text-pink-500">Estrogen:</span> Impacts fat distribution, metabolism, and emotional wellbeing. Low or fluctuating levels can cause mood swings and weight changes.</li>
              <li><span className="font-semibold text-pink-500">Thyroid Hormones:</span> Control metabolism and energy expenditure. Low levels can lead to fatigue and weight gain.</li>
            </ul>
          </div>
        </div>

        {/* 2️⃣ How Imbalance Manifests */}
        <div className="flex flex-col md:flex-row-reverse items-start gap-6">
          <img
            src="/assets/3.png"
            alt="Hormonal Imbalance Effects"
            className="w-full md:w-1/2 rounded-xl shadow-lg"
          />
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-bold text-pink-600 mb-3">
              How Imbalance Manifests
            </h2>
            <p className="text-lg md:text-xl mb-2">
              When these hormones are imbalanced, the body may react in multiple ways. Common signs include:
            </p>
            <ul className="list-disc list-inside ml-4 text-lg md:text-xl space-y-2">
              <li>Unexplained weight gain or difficulty losing weight</li>
              <li>Fatigue or low energy levels</li>
              <li>Mood swings, irritability, or anxiety</li>
              <li>Cravings for sugar or processed foods</li>
              <li>Poor sleep quality or feeling unrested</li>
            </ul>
            <p className="text-lg md:text-xl mt-2">
              Recognizing these early helps you take action with lifestyle, nutrition, and wellness tools to restore balance.
            </p>
          </div>
        </div>

        {/* 3️⃣ Supporting Hormonal Health */}
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-pink-600 mb-3">
            Supporting Hormonal Health Naturally
          </h2>
          <p className="text-lg md:text-xl mb-2">
            You can support hormone balance through simple daily habits:
          </p>
          <ul className="list-disc list-inside ml-4 text-lg md:text-xl space-y-2">
            <li>Eat balanced meals with protein, healthy fats, and fiber</li>
            <li>Prioritize 7-9 hours of quality sleep</li>
            <li>Manage stress with yoga, meditation, or mindfulness</li>
            <li>Stay hydrated and limit processed foods and sugar</li>
            <li>Engage in regular physical activity like walking, strength training, or swimming</li>
            <li>Consider high-quality supplements that support hormone balance</li>
          </ul>
        </div>

        {/* 4️⃣ Spearmint Tea Highlight Box */}
        <div className="bg-gradient-to-br from-green-50 via-white to-green-100 rounded-2xl p-8 shadow-lg text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-green-700 mb-4">
            Spearmint Tea for Hormonal Balance
          </h2>
          <p className="text-lg md:text-xl mb-4">
            Spearmint tea may help balance androgen levels, reduce mild hormonal symptoms, and support overall wellbeing. Enjoy a warm cup daily as part of a healthy routine.
          </p>
          <img
            src="/assets/ST.jpeg"
            alt="Spearmint Tea"
            className="w-40 mx-auto mb-4 rounded-xl shadow-md"
          />
          <button
            onClick={() => navigate("/category/supplements")}
            className="bg-green-500 text-white px-6 py-2 rounded-full font-semibold hover:bg-green-600 transition"
          >
            View Spearmint Tea Picks →
          </button>
        </div>

      </section>

      {/* ================= DISCLAIMER ================= */}
      <section className="bg-gray-50 py-12 px-6 text-center">
        <p className="max-w-3xl mx-auto text-sm text-gray-600">
          This content is for educational purposes only and does not replace professional medical advice. As an Amazon Associate, Glow Picks may earn from qualifying purchases.
        </p>
      </section>
    </div>
  );
}
